import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'

interface DefaultPaymentProps {
  amountWithCurrency: string
  merchantId: string
}

const DefaultPayment = ({ amountWithCurrency, merchantId }: DefaultPaymentProps) => {
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-with-currency"
          testId="amount-with-currency"
          title={i18next.t('transactions.sideBar.paymentOutAmountPaid')}
          body={amountWithCurrency}
        />
      )}

      {merchantId && (
        <DataListItem
          id="merchant-id"
          testId="merchant-id"
          title={i18next.t('transactions.sideBar.merchantId')}
          body={merchantId}
        />
      )}
    </>
  )
}

export default DefaultPayment
